<template>
  <section class="catalog-filter" :class="{ 'catalog-filter_active': show }" @wheel.prevent>
    <div class="catalog-filter__header">
      <span>{{ result.messages.title }}</span>
      <DefButtonCross @click="$emit('close')" />
    </div>
    <PerfectScrollbar class="catalog-filter__scroll">
      <form id="filter" class="filter" @submit.prevent="$emit('changeFilter')">
        <input v-for="item in result.hidden" :name="item.name" :value="item.value" type="hidden" />

        <CatalogFilterBlock v-if="getSelectedItems.length && !isUpdate" :result="true">
          <template #header>
            {{ result.messages.choose }}
          </template>
          <template #arrow
            >{{ pagination.elementsCount }} /
            {{ pagination.totalElementsCount }}
          </template>
          <CatalogFilterSelected
            :result="result"
            :selected-items="getSelectedItems"
            @resetFilter="$emit('resetFilter', result.actions.resetFilter.link)"
            @remove="$emit('remove', $event)"
          />
        </CatalogFilterBlock>

        <CatalogFilterBlock v-if="screenWidth < 768">
          <template #header>
            {{ sortMessage }}
          </template>
          <CatalogFilterSort />
        </CatalogFilterBlock>
        <CatalogFilterBlock
          v-if="savedFilters?.items?.length > 0"
          :key="savedFilters?.items?.length"
          :result="true"
        >
          <template #header>{{ filterMessages?.savedFilters }}</template>
          <CatalogSavedFilters />
        </CatalogFilterBlock>
        <div
          v-for="(block, i) in getFilterBlocksToShow"
          :key="block.ID"
          :class="{ 'reset-border': i === getFilterBlocksToShow.length - 1 }"
        >
          <CatalogFilterBlock
            v-if="block.DISPLAY_TYPE === 'A'"
            :result="block.CODE === 'MINIMUM_PRICE' || block.CODE === 'MIN_PRICE_EUR'"
          >
            <template #header>
              {{ block.NAME }}
              <DefInformText v-if="block?.PRINT_FILTER_HINT" parent=".catalog-filter__scroll">
                <template #content>
                  <span v-html="block?.PRINT_FILTER_HINT" />
                </template>
                <svg width="24" height="24"><use xlink:href="#svg-question"></use></svg>
              </DefInformText>
            </template>
            <CatalogRange :result="block" />
            <div v-if="block?.priceRange?.VALUES" class="filter__inputs">
              <DefCheckbox
                v-for="item in block.priceRange?.VALUES"
                :key="item.CONTROL_ID"
                :name="item.CONTROL_NAME"
                :checked="item.CHECKED"
                :disabled="item.DISABLED"
                value="Y"
              >
                {{ item.VALUE }}
                <span v-if="item?.ELEMENT_COUNT" class="filter__count"
                  >({{ item.ELEMENT_COUNT }})</span
                >
              </DefCheckbox>
            </div>
          </CatalogFilterBlock>

          <CatalogFilterBlock v-else :result="block.CODE === 'SPECIAL'">
            <template #header>
              <div class="filter-block-header">
                {{ block.NAME }}
                <DefInformText v-if="block?.PRINT_FILTER_HINT" parent=".catalog-filter__scroll">
                  <template #content>
                    <span v-html="block.PRINT_FILTER_HINT" />
                  </template>
                  <svg><use xlink:href="#svg-question"></use></svg>
                </DefInformText>
              </div>
            </template>
            <div class="filter__inputs">
              <DefCheckbox
                v-for="item in block.VALUES"
                :key="item.CONTROL_ID"
                :name="item.CONTROL_NAME"
                :checked="item.CHECKED"
                :disabled="item.DISABLED"
                value="Y"
              >
                <span
                  v-if="block.CODE === 'COLOR_METALL' || block.CODE === 'ST_VSTAVKA_COLOR'"
                  class="filter__color"
                  :style="{ 'background-color': item.COLOR }"
                ></span>
                <span
                  v-if="block.CODE === 'SPECIAL'"
                  :style="{ backgroundColor: item.COLOR }"
                  class="filter__special"
                  >{{ item.VALUE }}
                </span>
                <span v-else>{{ item.VALUE }}</span>
                <span v-if="item?.ELEMENT_COUNT" class="filter__count"
                  >({{ item.ELEMENT_COUNT }})</span
                >
              </DefCheckbox>
            </div>
          </CatalogFilterBlock>
        </div>
      </form>
    </PerfectScrollbar>
    <div class="filter-controls">
      <DefButtonSecondary
        v-if="result.actions && result.actions.resetFilter"
        type="reset"
        form="filter"
        @click="$emit('resetFilter', result.actions.resetFilter.link)"
      >
        {{ result.actions.resetFilter.text }}
      </DefButtonSecondary>
      <DefButtonPrimary type="submit" form="filter">
        {{ result.messages.accept }}
      </DefButtonPrimary>
    </div>
    <DefDarkenBackground v-if="show" @close="$emit('close')" />
  </section>
</template>

<script>
import { mapState } from 'vuex';
import CatalogFilterBlock from '@components/Catalog/CatalogFilter/CatalogFilterBlock.vue';
import CatalogFilterSelected from '@components/Catalog/CatalogFilter/CatalogFilterSelected.vue';
import CatalogFilterSort from '@components/Catalog/CatalogFilter/CatalogFilterSort.vue';
import DefInformText from '@components/Def/DefInformText/DefInformText.vue';
import CatalogRange from '@components/Catalog/CatalogFilter/CatalogRange.vue';
import DefCheckbox from '@components/Def/DefCheckbox/DefCheckbox.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import DefDarkenBackground from '@components/Def/DefDarkenBackground/DefDarkenBackground.vue';
import useScreenWidth from '@use/useScreenWidth';
import DefButtonCross from '@components/Def/DefButtonCross/DefButtonCross.vue';
import CatalogSavedFilters from '@components/Catalog/CatalogFilter/CatalogSavedFilters.vue';

export default {
  name: 'CatalogFilter',
  components: {
    CatalogSavedFilters,
    DefButtonCross,
    DefDarkenBackground,
    DefButtonSecondary,
    DefButtonPrimary,
    DefCheckbox,
    CatalogRange,
    DefInformText,
    CatalogFilterSort,
    CatalogFilterSelected,
    CatalogFilterBlock,
  },
  props: ['result', 'show'],
  data() {
    return {
      isUpdate: false,
      screenWidth: useScreenWidth(),
    };
  },
  computed: {
    ...mapState({
      sortMessage: ({ catalog }) => catalog?.data?.catalogSort?.messages?.sort,
      filterMessages: ({ catalog }) => catalog?.data?.catalogSmartFilter?.messages,
      savedFilters: ({ catalog }) => catalog?.data?.catalogSmartFilter?.savedFilters,
      pagination: ({ catalog }) => catalog?.data?.catalogSectionList?.pagination,
    }),
    getSelectedItems() {
      const items = this.result.ITEMS;
      const arr = [];

      if (items) {
        for (const key in items) {
          const subObj = items[key].VALUES;

          if (items[key].DISPLAY_TYPE === 'A') {
            /** get string for price range* */
            const range = {};
            const newObj = {
              ...items[key],
              CODE: items[key].CODE,
            };
            for (const i in subObj) {
              if (subObj[i].HTML_VALUE) {
                range[i] = subObj[i].HTML_VALUE;
              }
            }

            if (range && range.MIN && range.MAX) {
              newObj.printRange = `от ${range.MIN} до ${range.MAX}`;
            } else if (range.MIN) {
              newObj.printRange = `от ${range.MIN}`;
            } else if (range.MAX) {
              newObj.printRange = `до ${range.MAX}`;
            }
            if (newObj.printRange) {
              arr.push(newObj);
            }

            // range prices checkbox
            if (items[key]?.priceRange?.VALUES?.length) {
              items[key]?.priceRange?.VALUES.forEach((item) => {
                if (item.CHECKED) {
                  arr.push({ ...item, priceRange: true });
                }
              });
            }
          } else if (items[key].VALUES) {
            /** get all checkbox * */
            for (const i in subObj) {
              if (subObj[i].CHECKED) {
                arr.push({
                  ...subObj[i],
                  CODE: items[key].CODE,
                });
              }
            }
          }
        }
      }

      return arr;
    },
    getFilterBlocksToShow() {
      return this.result.ITEMS.filter((el) => el.CODE !== 'SKU_PRICE_RANGE');
    },
    skuPriceRange() {
      return this.result.ITEMS.find((el) => el.CODE === 'SKU_PRICE_RANGE');
    },
  },
  beforeUpdate() {
    this.isUpdate = true;
  },
  updated() {
    this.isUpdate = false;
  },
};
</script>

<style lang="scss" scoped>
.catalog-filter {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  max-width: 360px;
  background-color: #fff;
  z-index: 10003;
  transform: translateX(-100%);
  transition: 0.2s linear all;
  max-height: 100%;
  @include point-md {
    max-width: 400px;
  }
  &_active {
    transform: translateX(0);
  }
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    background-color: var(--color-main);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 125%;
    text-transform: uppercase;
    padding: 0 16px;
    color: #fff;
    flex-shrink: 0;
    @include point-md {
      padding: 0 24px;
      font-size: rem(20);
    }
    :deep(.def-button-cross__icon) {
      width: 24px;
      height: 24px;
      fill: #fff;
    }
  }
  &__scroll {
    overflow-y: auto;
    position: relative;
  }
  :deep(.def-checkbox__input) {
    &:disabled + .def-checkbox__front,
    &:disabled + .def-checkbox__front + .def-checkbox__text {
      opacity: 0.5;
    }
  }
  :deep(.catalog-range) {
    margin-bottom: 16px;
  }
}

.filter {
  padding: 0 16px;
  @include point-md {
    padding: 0 24px;
  }
  &__inputs {
    display: grid;
    grid-row-gap: 16px;
  }
  &__color {
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 8px;
    border-radius: 50%;
    background-color: grey;
    position: relative;
    &:after {
      content: '';
      width: 18px;
      height: 18px;
      position: absolute;
      border: 1px solid #c8c8c8;

      left: -2px;
      top: -2px;
      border-radius: 50%;
    }
  }
  &__special {
    padding: 4px 8px;
  }
  &__count {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%;
    margin-left: 4px;
    color: #5f5f67;
  }
  :deep(.def-checkbox) {
    align-items: center;
  }
  :deep(.def-checkbox__text) {
    display: inline-flex;
    align-items: center;
  }
}

.filter-controls {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
  align-items: center;
  background-color: #fff;
  border-top: 1px solid var(--background-grey);
  padding: 12px 16px;
  margin-top: auto;
  @include point-md {
    padding: 16px 24px;
    grid-row-gap: 12px;
  }
  &__text {
    color: #5f5f67;
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    grid-column-start: 1;
    grid-column-end: 3;
    text-align: center;
  }
}
.close-control {
  border-top: 1px solid var(--background-grey);
  padding: 12px 16px;
  @include point-md {
    padding: 16px 24px;
  }
  :deep(.def-button-primary) {
    width: 100%;
  }
}
.filter-block-header {
  display: flex;
  align-items: center;
  gap: 8px;
  :deep(svg) {
    display: block;
    width: 20px;
    height: 20px;
    fill: #5f5f67;
  }
}
.reset-border {
  :deep(.catalog-filter-block) {
    border: unset;
  }
}
</style>
